export default "__VITE_ASSET__BmtJIpWc__";